<template>
  <div class="md-layout text-center">
    <div class="md-layout-item md-size-50 md-small-size-100 md-medium-size-100 logo-main">
      <img :src="logo" alt="">
    </div>

    <div class="md-layout-item md-size-50 md-small-size-100 md-medium-size-100">
      <OutsideNotifs v-if="notifShow" v-bind:message="notifMessage" v-bind:hasError="errorNotif" v-on:closeNotif="showNotif"/>
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(projectLogin)">
      <login-card>
        <div slot="login-header" class="login-header-wrapper">
          <h3 class="page-title">Reset Your Password</h3>
        </div>
        <div slot="inputs">
        <ValidationProvider
          name="email"
          rules="required|email"
          v-slot="{ passed, failed }"
        >
        <md-field class="md-form-group" :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
          <md-icon>email</md-icon>
          <label>Email</label>
          <md-input v-model="email" type="email"></md-input>
          <slide-y-down-transition>
            <md-icon class="error" v-show="failed">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon class="success" v-show="passed">done</md-icon>
          </slide-y-down-transition>
        </md-field>
      </ValidationProvider>
    </div>
        <md-button
          @click="sendReset"
          slot=footer
          class="md-simple md-success md-lg submit"
        >
          Reset My Password
        </md-button>
      </login-card>
      </form>
    </ValidationObserver>
    </div>
  </div>
</template>
<script>
import { LoginCard } from "@/components";
import OutsideNotifs from "@/pages/Dashboard/UserPages/Components/OutsideNotifs.vue"
import { extend } from "vee-validate";
import { required, email, confirmed } from "vee-validate/dist/rules";
import api from '@/api';

export default {
  components: {
    LoginCard,
    OutsideNotifs
  },
  props: {
    logo: {
      type: String,
      default: "./img/mainscs_logo.png"
    },
  },
  data() {
    return {
      email: null,
      notifMessage: '',
      errorNotif: false,
      notifShow: false,
    }
  },
  methods: {
    sendReset(){
      var obj = {
        user: {
          email: this.email
        }
      };
      api.sendPasswordReset(obj).then((response) => {
        console.log(response);
        this.changeNotif("Check your email for a link to reset your password", false)
      }).catch((errors) => {
        console.log(errors)
        this.changeNotif("There was an error in getting your reset email. Try again.", true)
      })
    },
    showNotif(){
      this.notifShow = !this.notifShow
    },
    changeNotif(message, type){
      this.notifMessage = message;
      this.errorNotif = type;
      this.notifShow = true;
    }

  }
}
</script>
<style lang="scss">
</style>
